import axios from './axios_interceptors'
import config from '@/services/config'

export default {
  searchTalent(email) {
    return axios.post(
      `${config.urlCore}/api/v3/user-agency/search-talent/`,
      { email },
      { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
    ).then(response => response.data.response)
  },

  getDealsByVanity(vanity_name) {
    return axios.post(
      `${config.urlCore}/api/v4/deals/by-vanity/${vanity_name}/`,
      {},
      { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
    ).then(response => response.data.response)
  },

  getTalentUserNetworks(email) {
    return axios.post(
      `${config.urlCore}/api/v3/user-agency/talent/user-networks/`,
      { email },
      { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
    ).then(response => response.data.response)
  },

  addTalentUserNetwork(email, network, username, followers) {
    return axios.post(
      `${config.urlCore}/api/v3/user-agency/talent/new/user-network/`,
      {
        email,
        network,
        username,
        followers,
      },
      { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
    ).then(response => response.data.response)
  },

  createProposal(formData) {
    return axios.post(
      `${config.urlCore}/api/v3/user-agency/talent/create-proposal/`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    ).then(response => response.data.response)
  },

  // Recibe el email, o un FormData cuando también se envían los datos del talento
  linkProposal(data) {
    return axios.post(
      `${config.urlCore}/api/v3/user-agency/link-proposal/`,
      data instanceof FormData ? data : { email: data },
      { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
    ).then(response => response.data.response)
  },

  editTalent(user_id, formData) {
    return axios.post(
      `${config.urlCore}/api/v3/user-agency/edit-talent/${user_id}/`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'Content-Type': 'multipart/form-data',
        },
      }
    ).then(response => response.data.response)
  },

  unlinkProposal(proposal_uuid) {
    return axios.get(
      `${config.urlCore}/api/v3/user-agency/unlink-proposal/${proposal_uuid}/`,
      { headers: { Authorization: `Bearer ${localStorage.getItem('accessToken')}` } }
    ).then(response => response.data.response)
  },
}
